import AddDecedent from '@/common/containers/Modals/AddDecedent/AddDecedent';
import { useAddDecedentMutation } from '@/entities/decedent';
import StepperProvider from '@/common/components/Stepper/StepperContext';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const WrappedAddDecedent = (props) => {
  const { t } = useTranslation();
  const addDecedentMutation = useAddDecedentMutation();
  const steps = useMemo(
    () => [t('Decedent info'), t('Primary account user')],
    [t]
  );

  return (
    <StepperProvider steps={steps}>
      <AddDecedent
        {...props}
        loading={addDecedentMutation.isPending}
        addDecedent={addDecedentMutation.mutateAsync}
      />
    </StepperProvider>
  );
};

export default WrappedAddDecedent;
